import moment from "moment";
import styles from "../index.module.css";
import { Pie, Bar } from "react-chartjs-2";
import { QRCodeSVG } from "qrcode.react";
import { totalLicensesActive } from "../../../actions/licenseAction.js";
import {
  getOngoingScheduled,
  getSessions,
} from "../../../actions/manageSessionsAction.js";
import { countGroups } from "../../../actions/manageGroupsActions.js";
import { getMetricInitialData } from "../../../actions/reportsActions.js";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import { connect } from "react-redux";
import {
  countCourses,
  getCourseNames,
} from "../../../actions/manageCoursesActions.js";
import { countUsers } from "../../../actions/manageUsersActions.js";
import { getStorageInfo } from "../../../actions/assetsAction.js";
import { getModulesIdsByUser } from "../../../actions/productsActions.js";
import Button from "../../../components/Button/index.jsx";
import TokensModal from "../tokensModal.jsx";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
);

const BoxLicenses = (props) => {
  const { licenses, totalLicensesActive, ready } = props;
  const [loading, setLoading] = useState(true);
  const mediaQuery = window.matchMedia("(max-width: 427px)");
  const navigate = useNavigate();

  const getInitialData = async () => {
    setLoading(true);
    try {
      if (ready) {
        await totalLicensesActive();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);

      // alert('ERROR', error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getInitialData();
  }, [ready]);

  return (
    <div className={styles.boxContainer} onClick={() => navigate("/licenses")}>
      <span className={styles.titleBox}>LICENSES</span>
      <div
        className={`${!mediaQuery ? styles.contentBox : styles.contentBoxTwoL}`}
      >
        {loading ? (
          <Skeleton
            animation="wave"
            className={styles.numberBiggest}
            variant="circular"
            width={80}
            height={80}
          />
        ) : (
          <div className={styles.numberBiggest}>{licenses}</div>
        )}
        {loading ? (
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={210}
            height={60}
          />
        ) : (
          <div className={styles.subTitle2}>ACTIVE</div>
        )}
      </div>
    </div>
  );
};
const ConnectedBoxLicenses = connect(null, { totalLicensesActive })(
  BoxLicenses,
);

const BoxSessions = (props) => {
  const { sessions, getOngoingScheduled, getSessions, ready } = props;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getInitialData = async () => {
    setLoading(true);
    try {
      if (ready) {
        await getOngoingScheduled();
        setLoading(false);
      }
    } catch (error) {
      // alert('ERROR', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getInitialData();
  }, [ready]);
  return (
    <div
      className={styles.boxContainer}
      onClick={() => navigate("/manage-sessions")}
    >
      <span className={styles.titleBox}>SESSIONS</span>
      <div className={styles.contentBox}>
        <div className={styles.sessionCon}>
          <div className={styles.deviceBox}>
            <div className={styles.subTitle}>ONGOING</div>
            {loading ? (
              <Skeleton
                animation="wave"
                className={styles.number}
                variant="circular"
                width={20}
                height={20}
              />
            ) : (
              <div className={styles.number}>{sessions.ongoing ?? 0}</div>
            )}
          </div>
          <div className={styles.deviceBox}>
            <div className={styles.subTitle4}>SCHEDULED</div>
            {loading ? (
              <Skeleton
                animation="wave"
                className={styles.number4}
                variant="circular"
                width={20}
                height={20}
              />
            ) : (
              <div className={styles.number4}>{sessions.scheduled ?? 0}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const ConnectedBoxSessions = connect(null, {
  getOngoingScheduled,
  getSessions,
})(BoxSessions);

const BoxGroups = (props) => {
  const { groups, countGroups, ready } = props;
  const [loading, setLoading] = useState(true);
  const mediaQuery = window.matchMedia("(max-width: 427px)");
  const navigate = useNavigate();
  const getInitialData = async () => {
    setLoading(true);
    try {
      if (ready) {
        await countGroups();
        setLoading(false);
      }
    } catch (error) {
      // alert('ERROR', error);
      setLoading(false);
    } finally {
    }
  };

  useEffect(() => {
    console.log("groups ready", ready);
    getInitialData();
  }, [ready]);

  return (
    <div
      className={styles.boxContainer}
      onClick={() => navigate("/manage-groups")}
    >
      <span className={styles.titleBox}>GROUPS</span>
      {groups ? (
        <div
          className={`${
            !mediaQuery ? styles.contentBox : styles.contentBoxTwo
          }`}
        >
          <div className={styles.numberBig}>{groups}</div>
          <div className={styles.subTitle2}>AVAILABLE</div>
        </div>
      ) : (
        <div
          className={`${
            !mediaQuery ? styles.contentBox : styles.contentBoxTwo
          }`}
        >
          {loading ? (
            <Box sx={{ display: "flex", width: "70%" }}>
              <Skeleton
                sx={{ marginRight: 2 }}
                animation="wave"
                variant="circular"
                width={60}
                height={60}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={200}
                height={40}
              />
            </Box>
          ) : (
            <div className={styles.subTitle5}>NO GROUPS CREATED</div>
          )}
        </div>
      )}
    </div>
  );
};
const ConnectedBoxGroups = connect(null, { countGroups })(BoxGroups);

const BoxCourses = (props) => {
  const { courses, countCourses, ready } = props;
  const [loading, setLoading] = useState(true);
  const mediaQuery = window.matchMedia("(max-width: 427px)");
  const navigate = useNavigate();
  const getInitialData = async () => {
    setLoading(true);
    try {
      if (ready) {
        await countCourses();
        setLoading(false);
      }
    } catch (error) {
      // alert('ERROR', error);
    } finally {
    }
  };

  useEffect(() => {
    getInitialData();
  }, [ready]);

  return (
    <div
      className={styles.boxContainer}
      onClick={() => navigate("/manage-courses")}
    >
      <span className={styles.titleBox}>COURSES</span>
      {courses ? (
        <div
          className={`${
            !mediaQuery ? styles.contentBox : styles.contentBoxTwo
          }`}
        >
          <div className={styles.numberBig}>{courses}</div>
          <div className={styles.subTitle2}>AVAILABLE</div>
        </div>
      ) : (
        <div
          className={`${
            !mediaQuery ? styles.contentBox : styles.contentBoxTwo
          }`}
        >
          {loading ? (
            <Box sx={{ display: "flex", width: "70%" }}>
              <Skeleton
                sx={{ marginRight: 2 }}
                animation="wave"
                variant="circular"
                width={60}
                height={60}
              />
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={200}
                height={40}
              />
            </Box>
          ) : (
            <div className={styles.subTitle5}>NO COURSES CREATED</div>
          )}
        </div>
      )}
    </div>
  );
};
const ConnectedBoxCourses = connect(null, { countCourses })(BoxCourses);

const BoxUsers = (props) => {
  const { totalUsers, inactiveUsers, activeUsers, countUsers, ready } = props;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const getInitialData = async () => {
    setLoading(true);
    try {
      if (ready) {
        await countUsers();
        setLoading(false);
      }
    } catch (error) {
      // alert('ERROR', error);
      setLoading(false);
    } finally {
    }
  };

  useEffect(() => {
    getInitialData();
  }, [ready]);

  return (
    <div
      className={styles.boxContainer}
      onClick={() => navigate("/manage-users")}
    >
      <span className={styles.titleBox}>USERS</span>
      <div className={styles.contentBox}>
        <div className={styles.sessionCon}>
          <div className={styles.deviceBox}>
            <div className={styles.subTitle}>TOTAL</div>
            {loading ? (
              <Skeleton
                animation="wave"
                className={styles.number}
                variant="circular"
                width={20}
                height={20}
              />
            ) : (
              <div className={styles.number}>{totalUsers}</div>
            )}
          </div>
          <div className={styles.deviceBox}>
            <div className={styles.subTitle4}>INACTIVE</div>
            {loading ? (
              <Skeleton
                animation="wave"
                className={styles.number4}
                variant="circular"
                width={20}
                height={20}
              />
            ) : (
              <div className={styles.number4}>{inactiveUsers}</div>
            )}
          </div>
          <div className={styles.deviceBox}>
            <div className={styles.subTitle4}>ACTIVE</div>
            {loading ? (
              <Skeleton
                animation="wave"
                className={styles.number4}
                variant="circular"
                width={20}
                height={20}
              />
            ) : (
              <div className={styles.number4}>{activeUsers}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const ConnectedBoxUsers = connect(null, { countUsers })(BoxUsers);

const BoxReports = (props) => {
  const { reports = [], getMetricInitialData, ready } = props;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const getInitialData = async () => {
    setLoading(true);
    try {
      if (ready) {
        await getMetricInitialData();
        setLoading(false);
      }
    } catch (error) {
      // alert('ERROR', error);
      setLoading(false);
    } finally {
    }
  };

  useEffect(() => {
    getInitialData();
    console.log(reports.length, loading);
  }, [ready]);
  const fiveReports = reports.slice(0, 5);
  const data = {
    labels: fiveReports.map((report) => report.productName),
    datasets: [
      {
        label: "Reports",
        data: fiveReports.map((report) => report.seconds / 60),
        backgroundColor: [
          "#876abf",
          "#b2b6fe",
          "#876abf",
          "#b2b6fe",
          "#876abf",
        ],
        barPercentage: 0.7,
        // hoverOffset: 4,
        borderWidth: 0,
      },
    ],
  };
  const options = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
        },
      },
      y: {
        ticks: {
          callback: function (value, index, values) {
            return value + " min";
          },
          font: {
            size: 9,
            family: "ProximaNova-Regular",
            weight: "bold",
          },
        },
      },
    },
  };
  return (
    <div className={styles.boxContainer} onClick={() => navigate("/reports")}>
      <span className={styles.titleBox}>REPORTS</span>
      <div className={styles.contentBox}>
        {
          <div className={styles.reportTable}>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width={250}
                  height={200}
                />
              </Box>
            ) : reports.length === 0 ? (
              <div className={styles.subTitle5}>NO REPORTS AVAILABLE</div>
            ) : (
              <Bar data={data} options={options} />
            )}
          </div>
        }
      </div>
    </div>
  );
};
const ConnectedBoxReports = connect(null, { getMetricInitialData })(BoxReports);

const BoxAssets = (props) => {
  const { storage, mediaQuery, smally, has_storage, getStorageInfo, ready } =
    props;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const getInitialData = async () => {
    setLoading(true);
    try {
      if (ready) {
        if (has_storage) {
          await getStorageInfo();
          setLoading(false);
        } else {
          setLoading(false);
        }
      }
    } catch (error) {
      // alert('ERROR', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getInitialData();
  }, [ready]);
  const unit = storage.total > 1020 * 1020 * 1020 ? "GB" : "MB";
  const used = (
    storage.used / (unit === "GB" ? 1020 * 1020 * 1020 : 1020 * 1020)
  ).toFixed(1);
  const free = (
    storage.free / (unit === "GB" ? 1020 * 1020 * 1020 : 1020 * 1020)
  ).toFixed(1);
  const total = (
    storage.total / (unit === "GB" ? 1020 * 1020 * 1020 : 1020 * 1020)
  ).toFixed(1);
  const data = {
    labels: ["Free", "Used"],
    datasets: [
      {
        label: "Storage",
        data: [free, used],
        backgroundColor: ["#b2b6fe", "#876abf"],
        // hoverOffset: 4,
        borderWidth: 0,
      },
    ],
  };
  const options = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "right",
        // align: 'center',
        labels: {
          boxWidth: 25,
          boxHeight: 25,
          padding: 20,
          font: {
            size: 18,
            family: "ProximaNova-Regular",
            weight: "bold",
          },
        },
      },
    },
  };
  const optionsMobile = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "right",
        // align: 'center',
        labels: {
          boxWidth: 15,
          boxHeight: 15,
          padding: 20,
          font: {
            size: 10,
            family: "ProximaNova-Regular",
            weight: "bold",
          },
        },
      },
    },
  };
  return (
    <div
      className={`${styles.boxContainer} ${!has_storage && styles.disabled}`}
      onClick={() => {
        has_storage && navigate("/Assets");
      }}
    >
      <span className={styles.titleBox}>ASSETS</span>
      <div className={styles.contentBox}>
        {has_storage ? (
          <div className={styles.pieContainer}>
            <div className={`${styles.pie} ${smally && styles.smally}`}>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={180}
                    height={180}
                  />
                </Box>
              ) : (
                <Pie
                  data={data}
                  options={mediaQuery ? optionsMobile : options}
                />
              )}
            </div>
            {loading ? (
              <Skeleton
                animation="wave"
                variant="rectangular"
                width={300}
                height={25}
              />
            ) : (
              <div
                className={styles.textStorage}
              >{`STORAGE    ${used} ${unit} / ${total} ${unit}`}</div>
            )}
          </div>
        ) : (
          <div className={styles.subTitle5}>ASSETS STORAGE NOT AVAILABLE</div>
        )}
      </div>
    </div>
  );
};
const ConnectedBoxAssets = connect(null, { getStorageInfo })(BoxAssets);

const BoxToken = (props) => {
  const {
    token,
    timer,
    noProducts,
    canGenerateTokens,
    setOpenModal,
    openModal,
    courses,
    setCode,
  } = props;
  const mediaQuery = window.matchMedia("(max-width: 427px)");
  const tabletMediaQueryHeight = window.matchMedia("(max-height: 650px)");
  const [loading, setLoading] = useState(true);

  const getInitialData = async () => {
    setLoading(true);
    if (token) {
      setCode(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    getInitialData();
  }, [token]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  let qrSize = 200; // valor por defecto (desktop)
  if (tabletMediaQueryHeight.matches) {
    qrSize = 200; // tablet (por altura)
  }
  if (mediaQuery.matches) {
    qrSize = 200; // mobile
  }

  return (
    <div className={styles.boxContainer}>
      <span className={styles.titleBox}>TOKEN</span>
      <div className={styles.contentBox}>
        {noProducts ? (
          <div className={styles.noTokenContainer}>
            <div className={styles.noToken}>
              You do not have access to any VR Experiences
            </div>
          </div>
        ) : (
          <div className={styles.tokenContainer}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {loading ? (
              <Skeleton
                animation="wave"
                className={styles.token}
                variant="circular"
                width={100}
                height={100}
              />
            ) : (
              <div className={styles.loopContainer}>
                <div className={styles.counter}>{formatTime(timer)}</div>
              </div>
            )}
              {loading ? (
                <Skeleton
                  sx={{ marginBottom: 1 }}
                  animation="wave"
                  variant="rectangular"
                  width={100}
                  height={100}
                />
              ) : (
                <QRCodeSVG value={token} size={qrSize} />
              )}
              {loading ? (
                <Skeleton
                  animation="wave"
                  className={styles.token}
                  variant="rectangular"
                  width={150}
                  height={40}
                />
              ) : (
                <div className={styles.token}>{token}</div>
              )}
            </div>            
          </div>
        )}

        {!noProducts && (
          <div className={styles.textContainer}>
            {loading ? (
              <Skeleton
                animation="wave"
                height={30}
                width={240}
                style={{ marginBottom: 0 }}
              />
            ) : (
              <div className={styles.subTitle22}>USE THIS CODE TO ACCESS</div>
            )}
            {loading ? (
              <Skeleton
                animation="wave"
                height={40}
                width={240}
                style={{ marginBottom: 0 }}
              />
            ) : (
              <div className={styles.subTitle22}>YOUR VR EXPERIENCE</div>
            )}
          </div>
        )}

        {canGenerateTokens && !loading && (
          <Button
            label="GENERATE TOKENS"
            size="medium"
            styleButton="main"
            buttonClass={styles.smallButton}
            onClick={() => setOpenModal(true)}
          />
        )}
      </div>
      {canGenerateTokens && (
        <TokensModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          courses={courses ?? []}
        />
      )}
    </div>
  );
};
const ConnectedBoxToken = connect(null, {
  getModulesIdsByUser,
  getCourseNames,
})(BoxToken);

const BoxSessions2 = (props) => {
  const { sessions, getSessions, ready } = props;
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getInitialData = async () => {
    setLoading(true);
    try {
      if (ready) {
        await getSessions();
        setLoading(false);
      }
    } catch (error) {
      // alert('ERROR', error);
    }
  };

  useEffect(() => {
    getInitialData();
  }, [ready]);
  const firstDate = sessions[0] ? moment(sessions[0].dateSession) : null;
  const secondDate = sessions[1] ? moment(sessions[1].dateSession) : null;
  const thirdDate = sessions[2] ? moment(sessions[2].dateSession) : null;
  const firstSession = sessions[0];
  const secondSession = sessions[1];
  const thirdSession = sessions[2];
  return (
    <div
      className={styles.boxContainer}
      onClick={() => navigate("/manage-sessions")}
    >
      <span className={styles.titleBox}>SESSIONS</span>
      <div className={styles.contentBox}>
        {sessions.length > 0 ? (
          <div className={styles.column}>
            <div className={styles.dateOut}>
              {firstDate?.format("MMM yyyy")}
            </div>
            {firstSession && (
              <div className={styles.row}>
                <div className={styles.chartContainer}>
                  <div className={styles.chartDate}>
                    <div className={styles.dayDate}>
                      {firstDate.format("ddd").toUpperCase()}
                    </div>
                    <div className={styles.numberDate}>
                      {firstDate.format("DD")}
                    </div>
                  </div>
                </div>
                <div className={styles.chartContainer}>
                  <div className={styles.titleContainer}>
                    <div className={styles.text1}>
                      {firstSession && firstSession.title}
                    </div>
                    <div className={styles.text2}>
                      {firstSession &&
                        firstSession.product &&
                        firstSession.product.name}
                    </div>
                  </div>
                </div>
                <div className={styles.hourDate}>
                  <div>
                    <div className={styles.hourDate}>
                      {firstDate.format("hh:mm A")}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className={styles.dateOut}>
              {secondDate?.format("MMM yyyy") !==
                firstDate?.format("MMM yyyy") && secondDate?.format("MMM yyyy")}
            </div>
            {secondSession && (
              <div className={styles.row2}>
                <div className={styles.chartContainer}>
                  <div className={styles.chartDate}>
                    <div className={styles.dayDate}>
                      {secondDate.format("ddd").toUpperCase()}
                    </div>
                    <div className={styles.numberDate}>
                      {secondDate.format("DD")}
                    </div>
                  </div>
                </div>
                <div className={styles.chartContainer}>
                  <div className={styles.titleContainer}>
                    <div className={styles.text1}>
                      {secondSession && secondSession.title}
                    </div>
                    <div className={styles.text2}>
                      {secondSession &&
                        secondSession.product &&
                        secondSession.product.name}
                    </div>
                  </div>
                </div>
                <div className={styles.hourDate}>
                  <div>
                    <div className={styles.hourDate}>
                      {secondDate.format("hh:mm A")}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className={styles.dateOut}>
              {thirdDate?.format("MMM yyyy") !==
                secondDate?.format("MMM yyyy") && thirdDate?.format("MMM yyyy")}
            </div>
            {thirdSession && (
              <div className={styles.row}>
                <div className={styles.chartContainer}>
                  <div className={styles.chartDate}>
                    <div className={styles.dayDate}>
                      {thirdDate.format("ddd").toUpperCase()}
                    </div>
                    <div className={styles.numberDate}>
                      {thirdDate.format("DD")}
                    </div>
                  </div>
                </div>
                <div className={styles.chartContainer}>
                  <div className={styles.titleContainer}>
                    <div className={styles.text1}>
                      {thirdSession && thirdSession.title}
                    </div>
                    <div className={styles.text2}>
                      {thirdSession &&
                        thirdSession.product &&
                        thirdSession.product.name}
                    </div>
                  </div>
                </div>
                <div className={styles.hourDate}>
                  <div>
                    <div className={styles.hourDate}>
                      {thirdDate.format("hh:mm A")}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : loading ? (
          <div className={styles.skeletonColumn}>
            <Skeleton
              animation="wave"
              variant="rectangular"
              width="100%"
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rectangular"
              width="100%"
              height={50}
            />
            <Skeleton
              animation="wave"
              variant="rectangular"
              width="100%"
              height={50}
            />
          </div>
        ) : (
          <div className={styles.subTitle5}>NO SESSIONS SCHEDULED</div>
        )}
      </div>
    </div>
  );
};
const ConnectedBoxSessions2 = connect(null, { getSessions })(BoxSessions2);

const BoxSessionsMobile = (props) => {
  const { sessions, getSessions } = props;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getInitialData = async () => {
    setLoading(true);
    try {
      await getSessions();
    } catch (error) {
      // alert('ERROR', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);
  const firstDate = sessions[0] ? moment(sessions[0].dateSession) : null;
  const secondDate = sessions[1] ? moment(sessions[1].dateSession) : null;
  const thirdDate = sessions[2] ? moment(sessions[2].dateSession) : null;
  const firstSession = sessions[0];
  const secondSession = sessions[1];
  const thirdSession = sessions[2];
  return (
    <div
      className={styles.boxContainer2}
      onClick={() => navigate("/manage-sessions")}
    >
      <span className={styles.titleBox}>SESSIONS</span>
      <div className={styles.contentBox}>
        {sessions.length === 0 ? (
          <div className={styles.subTitle5}>NO SESSIONS SCHEDULED</div>
        ) : loading ? (
          <div className={styles.skeletonColumn}>
            <Skeleton
              animation="wave"
              variant="rectangular"
              width="100%"
              height={120}
            />
            <Skeleton
              animation="wave"
              variant="rectangular"
              width="100%"
              height={120}
            />
            <Skeleton
              animation="wave"
              variant="rectangular"
              width="100%"
              height={120}
            />
          </div>
        ) : (
          <div className={styles.column2}>
            {firstSession && (
              <div className={styles.row}>
                <div className={styles.dateOut}>
                  {firstDate?.format("MMM yyyy")}
                </div>
                <div className={styles.chartContainer}>
                  <div className={styles.chartDate}>
                    <div className={styles.dayDate}>
                      {firstDate.format("ddd").toUpperCase()}
                    </div>
                    <div className={styles.numberDate}>
                      {firstDate.format("DD")}
                    </div>
                  </div>
                </div>
                <div className={styles.chartContainer2}>
                  <div className={styles.titleContainer}>
                    <div className={styles.text1}>
                      {firstSession && firstSession.title}
                    </div>
                    <div className={styles.text2}>
                      {firstSession &&
                        firstSession.product &&
                        firstSession.product.name}
                    </div>
                    <div className={styles.hourDate}>
                      {firstDate.format("hh:mm A")}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {secondSession && (
              <div className={styles.row2}>
                <div className={styles.dateOut}>
                  {secondDate?.format("MMM yyyy") !==
                    firstDate?.format("MMM yyyy") &&
                    secondDate?.format("MMM yyyy")}
                </div>
                <div className={styles.chartContainer}>
                  <div className={styles.chartDate}>
                    <div className={styles.dayDate}>
                      {secondDate.format("ddd").toUpperCase()}
                    </div>
                    <div className={styles.numberDate}>
                      {secondDate.format("DD")}
                    </div>
                  </div>
                </div>
                <div className={styles.chartContainer2}>
                  <div className={styles.titleContainer}>
                    <div className={styles.text1}>
                      {secondSession && secondSession.title}
                    </div>
                    <div className={styles.text2}>
                      {secondSession &&
                        secondSession.product &&
                        secondSession.product.name}
                    </div>
                    <div className={styles.hourDate}>
                      {secondDate.format("hh:mm A")}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {thirdSession && (
              <div className={styles.row}>
                <div className={styles.dateOut}>
                  {thirdDate?.format("MMM yyyy") !==
                    secondDate?.format("MMM yyyy") &&
                    thirdDate?.format("MMM yyyy")}
                </div>
                <div className={styles.chartContainer}>
                  <div className={styles.chartDate}>
                    <div className={styles.dayDate}>
                      {thirdDate.format("ddd").toUpperCase()}
                    </div>
                    <div className={styles.numberDate}>
                      {thirdDate.format("DD")}
                    </div>
                  </div>
                </div>
                <div className={styles.chartContainer2}>
                  <div className={styles.titleContainer}>
                    <div className={styles.text1}>
                      {thirdSession && thirdSession.title}
                    </div>
                    <div className={styles.text2}>
                      {thirdSession &&
                        thirdSession.product &&
                        thirdSession.product.name}
                    </div>
                    <div className={styles.hourDate}>
                      {thirdDate.format("hh:mm A")}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
const ConnectedBoxSessionsMobile = connect(null, { getSessions })(
  BoxSessionsMobile,
);

export {
  ConnectedBoxLicenses as BoxLicenses,
  ConnectedBoxSessions as BoxSessions,
  ConnectedBoxGroups as BoxGroups,
  ConnectedBoxCourses as BoxCourses,
  ConnectedBoxUsers as BoxUsers,
  ConnectedBoxReports as BoxReports,
  ConnectedBoxAssets as BoxAssets,
  ConnectedBoxToken as BoxToken,
  ConnectedBoxSessions2 as BoxSessions2,
  ConnectedBoxSessionsMobile as BoxSessionsMobile,
};
